export const BUTTON_OPEN_MODAL = 'filter_menu__button_open_modal';
export const STICKY_NAV = 'filter_menu__sticky_nav';
export const BUTTON_RESET_FILTERS = 'filter_menu__button_reset_fiters';
